import type { ApiErrorType } from '@/infra/api'
import type { EnvironmentValue, ExpirationOptionValue } from './constants'

export type ApiKeyEnvironment = 'dev' | 'test' | 'live'

export interface ApiKeyResponse {
  readonly apiKey: string
  readonly keyPrefix: string
  readonly type?: ApiKeyEnvironment
  readonly name: string
  readonly expiresAt: string | null
  readonly createdAt: string
}

export interface ApiKeyGenerationRequest {
  readonly name: string
  readonly environment: ApiKeyEnvironment
  readonly expiresAt?: string
}

export type ApiKeyError = ApiErrorType

export type WizardStep = 'welcome' | 'configuration' | 'display'

export interface ApiKeyFormState {
  readonly name: string
  readonly environment: EnvironmentValue
  readonly expirationDays: ExpirationOptionValue
  readonly customExpirationDate: Date | null
}

export interface ApiKeyWizardState {
  readonly step: WizardStep
  readonly form: ApiKeyFormState
  readonly generatedKey: ApiKeyResponse | null
  readonly error: string | null
}

export function expirationToIsoTimestamp(
  expirationDays: ExpirationOptionValue,
  customDate: Date | null,
): string | null {
  if (expirationDays === null) return null
  if (expirationDays === 'custom' && customDate) {
    return customDate.toISOString()
  }
  if (typeof expirationDays === 'number') {
    const date = new Date()
    date.setDate(date.getDate() + expirationDays)
    return date.toISOString()
  }
  return null
}
